import { CLink } from './CLink';
const CCLinkPlugin = {
    install: (app) => {
        app.component(CLink.name, CLink);
    },
};
export { CCLinkPlugin, CLink };
